export const INSTAGRAM_LINK = 'https://www.instagram.com/pandasushi.br/'

export const ALCOOLIC_DRINKS_CATEGORY_ID = '652ad05890ed25ad1e9fed91'

export const NON_ALCOOLIC_DRINKS_CATEGORY_ID = '653040dec7f5aa3109f60d78'

export const SUSHI_SET_CATEGORY_ID = '6525bec08f1961f80456f8b9'

export const FOOD_SET_CATEGORY_ID = '655f5cb44b52130cc63794fc'
